import LegalLayout from '../components/LegalLayout'

export default function Privacidad() {
  return (
    <LegalLayout
      title="Política de privacidad"
      description="Política de privacidad de PresenzIA: qué datos tratamos, con qué base legal, durante cuánto tiempo y cómo ejercer tus derechos RGPD."
      lastUpdate="3 de mayo de 2026"
      canonicalPath="/privacidad"
    >
      <p>
        En PresenzIA tratamos datos personales en cumplimiento del Reglamento (UE) 2016/679
        (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD). Esta política explica qué datos tratamos,
        con qué base legal, durante cuánto tiempo y cómo puedes ejercer tus derechos.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li><strong>Titular:</strong> 1MB Software (en adelante, "PresenzIA").</li>
        <li><strong>Sitio web:</strong> https://presenzia.app</li>
        <li><strong>Contacto general:</strong> info@presenzia.app</li>
        <li><strong>Contacto Delegado de Protección de Datos (DPO):</strong> privacidad@presenzia.app</li>
      </ul>
      <p>
        Si necesitas más información sobre el responsable, puedes solicitarla al email indicado.
      </p>

      <h2>2. Datos que tratamos</h2>
      <p>Recogemos y tratamos los siguientes datos personales:</p>
      <ul>
        <li><strong>Datos de cuenta:</strong> nombre, email, teléfono, contraseña cifrada.</li>
        <li><strong>Datos de empresa:</strong> nombre comercial, CIF, dirección, datos del administrador.</li>
        <li><strong>Datos laborales:</strong> registros de fichaje (entrada, salida, pausas, ausencias) de los empleados que el cliente da de alta.</li>
        <li><strong>Datos de geolocalización:</strong> sólo si la empresa lo activa expresamente para sus empleados.</li>
        <li><strong>Datos técnicos:</strong> dirección IP de fichajes (para auditoría), navegador, dispositivo, logs de acceso.</li>
        <li><strong>Datos de facturación:</strong> gestionados por Stripe (PCI-DSS), no almacenamos números de tarjeta.</li>
      </ul>

      <h2>3. Finalidades y base legal</h2>
      <table>
        <thead>
          <tr><th>Finalidad</th><th>Base legal</th></tr>
        </thead>
        <tbody>
          <tr><td>Prestar el servicio de control horario</td><td>Ejecución de contrato (art. 6.1.b RGPD)</td></tr>
          <tr><td>Cumplir el RD-Ley 8/2019 de registro de jornada</td><td>Obligación legal (art. 6.1.c RGPD)</td></tr>
          <tr><td>Facturación y cobros vía Stripe</td><td>Ejecución de contrato + obligación legal</td></tr>
          <tr><td>Envío de comunicaciones del servicio (verificación, avisos)</td><td>Ejecución de contrato</td></tr>
          <tr><td>Envío de comunicaciones comerciales</td><td>Consentimiento explícito (art. 6.1.a RGPD)</td></tr>
          <tr><td>Analítica web (Google Analytics 4)</td><td>Consentimiento del usuario en el banner de cookies</td></tr>
          <tr><td>Atención a solicitudes legales o requerimientos</td><td>Obligación legal e interés legítimo</td></tr>
        </tbody>
      </table>

      <h2>4. Plazos de conservación</h2>
      <ul>
        <li><strong>Cuenta activa:</strong> mientras se mantenga el contrato.</li>
        <li><strong>Tras la baja:</strong> 4 años para obligaciones fiscales y laborales.</li>
        <li><strong>Registros de fichaje:</strong> mínimo 4 años (art. 34.9 ET).</li>
        <li><strong>Logs técnicos e IPs:</strong> 12 meses, salvo obligación contable mayor.</li>
        <li><strong>Datos comerciales (leads sin convertir):</strong> 24 meses desde el último contacto.</li>
      </ul>

      <h2>5. Destinatarios y encargados de tratamiento</h2>
      <p>Compartimos datos únicamente con encargados de tratamiento que cumplen las garantías RGPD:</p>
      <ul>
        <li><strong>Stripe Payments Europe Ltd. (Irlanda):</strong> procesamiento de pagos.</li>
        <li><strong>Sendinblue / Brevo (Francia):</strong> envío de emails transaccionales y de marketing.</li>
        <li><strong>Proveedor de hosting (UE):</strong> servidores ubicados en la Unión Europea.</li>
        <li><strong>Google Ireland Ltd. (Irlanda):</strong> Google Analytics 4, sólo si el usuario lo consiente.</li>
      </ul>
      <p>
        No realizamos transferencias internacionales fuera del Espacio Económico Europeo
        salvo que estén amparadas por las cláusulas contractuales tipo de la Comisión Europea.
      </p>

      <h2>6. Tus derechos</h2>
      <p>Tienes derecho a:</p>
      <ul>
        <li><strong>Acceso:</strong> saber qué datos tuyos tratamos.</li>
        <li><strong>Rectificación:</strong> corregir datos inexactos.</li>
        <li><strong>Supresión:</strong> solicitar la eliminación cuando proceda.</li>
        <li><strong>Limitación del tratamiento:</strong> en los casos previstos por el RGPD.</li>
        <li><strong>Portabilidad:</strong> recibir tus datos en formato estructurado.</li>
        <li><strong>Oposición:</strong> oponerte al tratamiento por motivos legítimos.</li>
        <li><strong>Revocar el consentimiento:</strong> en cualquier momento, sin efecto retroactivo.</li>
      </ul>
      <p>
        Para ejercerlos, escribe a <strong>privacidad@presenzia.app</strong> aportando una copia
        de tu DNI o documento equivalente. Responderemos en el plazo máximo de 30 días.
      </p>
      <p>
        Si consideras que tus derechos no han sido atendidos correctamente, puedes presentar
        una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong>
        en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.
      </p>

      <h2>7. Seguridad</h2>
      <p>
        Aplicamos medidas técnicas y organizativas para garantizar la confidencialidad,
        integridad y disponibilidad de los datos: cifrado en tránsito (TLS 1.2+),
        contraseñas con hash bcrypt, control de accesos por rol, copias de seguridad
        periódicas, auditoría de accesos y servidores en la UE.
      </p>

      <h2>8. Tratamiento de datos de los empleados de nuestros clientes</h2>
      <p>
        Cuando una empresa contrata PresenzIA, sus empleados son los titulares de los datos
        de fichaje. En este caso, <strong>la empresa es la responsable del tratamiento</strong>
        y PresenzIA actúa como <strong>encargado de tratamiento</strong> en virtud del
        contrato suscrito (art. 28 RGPD). Los empleados deben dirigirse a su empresa para
        ejercer sus derechos.
      </p>

      <h2>9. Cambios en esta política</h2>
      <p>
        Podemos actualizar esta política. Los cambios sustanciales se notificarán por email
        a los administradores con al menos 15 días de antelación.
      </p>
    </LegalLayout>
  )
}
